import React from 'react';
import styles from './learn-why-tooltip.module.scss';
import { Flex } from '@workday/canvas-kit-react';
import { Tooltip, TooltipButton } from '@workday/upc-common';
import { useTranslation } from 'react-i18next';

export function LearnWhyToolTip() {
    const { t } = useTranslation('account');

    return (
        <Flex alignItems='center'>
            <p className={styles.text}>{t('LearnWhyTooltip.message')}</p>
            <Tooltip message={t('LearnWhyTooltip.tooltipMessage')}>
                <TooltipButton>{t('LearnWhyTooltip.buttonText')}</TooltipButton>
            </Tooltip>
        </Flex>
    );
}
